import React, { PureComponent } from 'react'
import { Map, FeatureGroup } from 'react-leaflet'
import '../../styles/leaflet.scss'
import styles from './ViewSupply.scss'
import { EditControl } from 'react-leaflet-draw'
import { searchToObject } from '../../utils/index'

type IMapWrapper_Props = {
    SetMapRef: (ref: any) => void,
    isSidebarOpened: boolean,
    minZoom: number,
    maxZoom: number,
    position: Point,
    initialZoom: number,
    maxBounds: PointArray,
    onMapMove: () => {},
    onZoomEnd: () => {},
    onMoveEnd: () => {},
    children?: any
}
type IMapWrapper_State = {}

const searchParams = searchToObject()

export const IS_DEV_MODE = Object.keys(searchParams).indexOf('devmode') !== -1 && searchParams.devmode !== false

class MapWrapper extends PureComponent<IMapWrapper_Props, IMapWrapper_State> {

    _onCreated = (e) => {
        if (e.layer && e.layerType === 'circle') {
            const b = e.layer.getBounds()
            const topRight = b._northEast.lng

            const x = e.layer._latlng.lng
            const y = e.layer._latlng.lat

            let r = topRight - x
            if (r < 0) {
                r = -r
            }

            const pos = {
                center: {
                    x: x,
                    y: y,
                },
                radius: r,
            }

            console.log('CIRCLE POSITION', pos)

            e.layer.on('click', (e) => {
                console.log('CIRCLE POSITION', pos)
            })

        }
    }

    render() {
        return (
            <Map
                inertia={false}
                ref={this.props.SetMapRef}
                key={`Map_${this.props.minZoom}`}
                className={`${styles.viewMap} ${this.props.isSidebarOpened ? styles.viewMapOpened : ''}`}
                maxBoundsViscosity={1}
                minZoom={this.props.minZoom}
                maxZoom={this.props.maxZoom}
                touchZoom={false}
                bounceAtZoomLimits={false}
                scrollWheelZoom={true}
                doubleClickZoom={false}
                center={this.props.position}
                zoom={this.props.initialZoom}
                maxBounds={this.props.maxBounds}
                onmove={this.props.onMapMove}
                onmoveend={this.props.onMoveEnd}
                onzoomstart={this.props.onZoomStart}
                onzoomend={this.props.onZoomEnd}
                onclick={this.props.onClick}
            >
                {this.props.children}

                {IS_DEV_MODE ? (
                    <FeatureGroup>
                        <EditControl
                            position="bottomright"
                            onCreated={this._onCreated}
                            draw={{
                                polyline: false,
                                polygon: false,
                                rectangle: false,
                                marker: false,
                                circlemarker: false,
                            }}
                        />
                    </FeatureGroup>
                ) : null}
            </Map>
        )
    }
}

export default MapWrapper